import * as types from './mutations-types'

const mutations = {
  [types.SET_COMMODITY](state, list) {
    state.commodityData = list
  },
  [types.SET_BACKAUTH](state, list) {
    state.backAuth = list
  },
  [types.SET_FRONTEND](state, frontend) {
    state.frontend = frontend
  },
  [types.SET_COMPONENT](state, component) {
    state.component = component
  },
  [types.SET_PROPERTY](state, property) {
    state.property = property
  },
  [types.SWITCH_SOURCE_BEAN](state, sourceBean) {
    state.source_bean = sourceBean
  },
  [types.SWITCH_SOURCE_LIST](state, sourceList) {
    state.source_list = sourceList
  },
  // 备忘录
  [types.MEMO_DIALOG_ISOPEN](state, memoDialogIsOpen) {
    state.memo_dialog_isopen = memoDialogIsOpen
  },
  // 项目
  [types.PROJECT_STATUS](state, projectStatus) {
    state.project_status = projectStatus
  },
  // 项目
  [types.PROJECT_LAYOUT_CHANGE](state, projectLayoutChange) {
    state.PROJECT_LAYOUT_CHANGE = projectLayoutChange
  },
  // 项目
  [types.SET_SALARYSCHEME](state, data) {
    state.salaryScheme = data
  },
  // 门户
  [types.SET_WORKBENCH_SETTING](state, data) {
    state.workbenchSetting = data
  },
  // 列表布局
  [types.SET_LISTLAYOUT_STYLE](state, data) {
    state.list_layout_style = data
  },
  // 详情布局
  [types.SET_DETAILSLAYOUT_STYLE](state, data) {
    state.details_layout_style = data
  },
  // 详情布局
  [types.SET_SYSTEM_MODEULE_LIST](state, data) {
    state.systemModuleList = data
  },
  // 考核设置
  [types.SET_PERFORMANCE_SETTING](state, data) {
    state.setting = data
  }
  // 自定义模块
  // [types.CUSTOM_LAYOUT] (state, layout) {
  //   state.custom_layout = layout
  // }
}

export default mutations
